module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: item[0],
      staticClass: "legend-row"
    }, [(typeof(item[1]) != 'object') ? _c('span', {
      staticClass: "column color",
      style: ({
        'background-color': _vm.getColor(item[0], index) + ' !important'
      })
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "column",
      style: ({
        'text-align': _vm.titleAlign
      })
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('span', {
      staticClass: "column total"
    }, [_vm._v(_vm._s(_vm.totalDisplay(item)))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da0b145a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/charts/ChartLegend.vue
// module id = 3403
// module chunks = 3